import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addCustomerVendor,
  deleteCustomerVendors,
  getCustomerVendors,
  updateCustomerVendor,
} from "controller/api";
import {
  ApiErrorType,
  GetCustomerVendorsInput,
  UpdateCustomerVendor,
} from "shared";
import { sentryLogger } from "utilz";

export const useGetAllCustomerVendors = ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
  customerId,
}: GetCustomerVendorsInput) => {
  return useQuery({
    queryKey: ["vendors", customerId],
    queryFn: () =>
      getCustomerVendors({
        perPageCount,
        pageNumber,
        sortColumn,
        sortDirection,
        filter,
        searchQuery,
        customerId,
      }),
    enabled: customerId ? true : false,
    onSuccess: (data) => {},
    onError: (error: ApiErrorType) => {
      console.log(error);
      sentryLogger({
        error: error,
        workflow: "customer",
        functionName: "getCustomerVendors",
      });
    },
  });
};

export const useAddCustomerVendor = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ customerIdParams, data }: any) =>
      addCustomerVendor({ customerIdParams, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vendors"]);
      },
      onError: (error: ApiErrorType) => {
        console.log(error);
        sentryLogger({
          error: error,
          workflow: "customer",
          functionName: "addCustomerVendor",
        });
      },
    }
  );
};

export const useUpdateCustomerVendor = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ vendorId, customerId, data }: UpdateCustomerVendor) =>
      updateCustomerVendor({ vendorId, customerId, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vendors"]);
      },
      onError: (error: ApiErrorType) => {
        console.log(error);
        sentryLogger({
          error: error,
          workflow: "customer",
          functionName: "updateCustomerVendor",
        });
      },
    }
  );
};

export const useDeleteCustomerVendor = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      customerIdParams,
      vendorIds,
    }: {
      customerIdParams: string;
      vendorIds: any;
    }) => deleteCustomerVendors({ customerIdParams, vendorIds }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vendors"]);
      },
      onError: (error: ApiErrorType) => {
        console.log(error);
        sentryLogger({
          error: error,
          workflow: "customer",
          functionName: "deleteCustomerVendors",
        });
      },
    }
  );
};
